import { JSX, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import { useGlobal } from '~/hooks/useGlobal';

import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import { BreadcrumbsItem } from '../../../stores/CatalogStore';

import MobileHeaderLayout from '../../Main/MobileHeader/MobileHeaderLayout';
import MobileHeaderTitle from '../../Main/MobileHeader/MobileHeaderTitle';

import styles from '../Legals.module.scss';

import mdStyles from './LegalsOkie.module.scss';

import '../styles.scss';

type Props = {
  handleLink: (anchor: string) => void;
};

const LEGALS_NAV = [
  {
    link: 'terms-and-conditions',
    title: 'Terms and Conditions',
  },
  {
    link: 'privacy-policy-main',
    title: 'Privacy Policy',
  },
];

const text = `
<h2 id="terms-and-conditions">Terms & Conditions</h2>
<p><strong>Last updated: 15 of June 2025</strong></p>

<h2>AGREEMENT TO OUR LEGAL TERMS</h2>


<p>We are JamNow ECOMMERCE SOLUTIONS - FZCO ("Company," "we," "us," "our"), a company registered in
UAE - Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, United Arab Emirates.
We operate the website <a href="https://www.jamnow.store/">https://www.jamnow.store/</a> (the "Site"), as well as any other related products and services
that refer or link to these legal terms (the "Legal Terms") (collectively, the "Services").
You can contact us by phone at 1800 2120 820, email at online@xportbridge.com.com, or by mail to - Building A1,
Dubai Digital Park, Dubai Silicon Oasis, Dubai, United Arab Emirates..</p>

<p>These Legal Terms constitute a legally binding agreement made between you, whether personally or on behalf of an
entity ("you"), and JamNow ECOMMERCE SOLUTIONS - FZCO, concerning your access to and use of the
Services. You agree that by accessing the Services, you have read, understood, and agreed to be bound by all of
these Legal Terms. IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY
PROHIBITED FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.</p>

<p>Supplemental terms and conditions or documents that may be posted on the Services from time to time are hereby
expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or
modifications to these Legal Terms at any time and for any reason. We will alert you about any changes by updating
the "Last updated" date of these Legal Terms, and you waive any right to receive specific notice of each such
change. It is your responsibility to periodically review these Legal Terms to stay informed of updates. You will be
subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Legal
Terms by your continued use of the Services after the date such revised Legal Terms are posted.</p>

<p>The Services are intended for users who are at least 18 years old. Persons under the age of 18 are not permitted to
use or register for the Services.</p

<p>We recommend that you print a copy of these Legal Terms for your records.</p>


<h2 id="services">1. OUR SERVICES</h2>


<p>The information provided when using the Services is not intended for distribution to or use by any person or entity in
any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would
subject us to any registration requirement within such jurisdiction or country. Accordingly, those persons who choose
to access the Services from other locations do so on their own initiative and are solely responsible for compliance
with local laws, if and to the extent local laws are applicable.</p>

<p>The Services are not tailored to comply with industry-specific regulations (Health Insurance Portability and
Accountability Act (HIPAA), Federal Information Security Management Act (FISMA), etc.), so if your interactions
would be subjected to such laws, you may not</p>

<h2 id="intellectual-property">2. INTELLECTUAL PROPERTY RIGHTS</h2>


<p>Our intellectual property</p>

<p>We are the owner or the licensee of all intellectual property rights in our Services, including all source code,
databases, functionality, software, website designs, audio, video, text, photographs, and graphics in the Services
(collectively, the "Content"), as well as the trademarks, service marks, and logos contained therein (the "Marks").
Our Content and Marks are protected by copyright and trademark laws (and various other intellectual property rights
and unfair competition laws) and treaties in the United States and around the world.</p>

<p>The Content and Marks are provided in or through the Services "AS IS" for your personal, non-commercial use or
internal business purpose only.</p>

Your use of our Services

Subject to your compliance with these Legal Terms, including the "PROHIBITED ACTIVITIES" section below, we
grant you a non-exclusive, non-transferable, revocable license to:
     access the Services; and
     download or print a copy of any portion of the Content to which you have properly gained access,
solely for your personal, non-commercial use or internal business purpose.

Except as set out in this section or elsewhere in our Legal Terms, no part of the Services and no Content or Marks
may be copied, reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated,
transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our
express prior written permission.

If you wish to make any use of the Services, Content, or Marks other than as set out in this section or elsewhere in
our Legal Terms, please address your request to: online@xportbridge.com.com. If we ever grant you the permission
to post, reproduce, or publicly display any part of our Services or Content, you must identify us as the owners or
licensors of the Services, Content, or Marks and ensure that any copyright or proprietary notice appears or is visible
on posting, reproducing, or displaying our Content.

We reserve all rights not expressly granted to you in and to the Services, Content, and Marks.
Any breach of these Intellectual Property Rights will constitute a material breach of our Legal Terms and your right to
use our Services will terminate immediately.

Your submissions

Please review this section and the "PROHIBITED ACTIVITIES" section carefully prior to using our Services to
understand the (a) rights you give us and (b) obligations you have when you post or upload any content through the
Services.

Submissions: By directly sending us any question, comment, suggestion, idea, feedback, or other information about
the Services ("Submissions"), you agree to assign to us all intellectual property rights in such Submission. You agree
that we shall own this Submission and be entitled to its unrestricted use and dissemination for any lawful purpose,
commercial or otherwise, without acknowledgment or compensation to you.
You are responsible for what you post or upload: By sending us Submissions through any part of the Services
you:
  <p>-confirm that you have read and agree with our "PROHIBITED ACTIVITIES" and will not post, send, publish,
    upload, or transmit through the Services any Submission that is illegal, harassing, hateful, harmful,
    defamatory, obscene, bullying, abusive, discriminatory, threatening to any person or group, sexually explicit,
    false, inaccurate, deceitful, or misleading;</p>
    <p>-to the extent permissible by applicable law, waive any and all moral rights to any such Submission;</p>
    <p>-warrant that any such Submission are original to you or that you have the necessary rights and licenses to
    submit such Submissions and that you have full authority to grant us the above-mentioned rights in relation
    to your Submissions; and</p>
    <p>-warrant and represent that your Submissions do not constitute confidential information.</p>

You are solely responsible for your Submissions and you expressly agree to reimburse us for any and all losses that
we may suffer because of your breach of (a) this section, (b) any third party’s intellectual property rights, or (c)
applicable law

<h2 id="user-representations">3. USER REPRESENTATIONS</h2>


By using the Services, you represent and warrant that: (1) you have the legal capacity and you agree to comply with
these Legal Terms; (2) you are not a minor in the jurisdiction in which you reside; (3) you will not access the Services
through automated or non-human means, whether through a bot, script or otherwise; (4) you will not use the Services
for any illegal or unauthorized purpose; and (5) your use of the Services will not violate any applicable law or
regulation.

If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or
terminate your account and refuse any and all current or future use of the Services (or any portion thereof).

<h2 id="prohibited-activities">4. PROHIBITED ACTIVITIES</h2>


You may not access or use the Services for any purpose other than that for which we make the Services available.
The Services may not be used in connection with any commercial endeavors except those that are specifically
endorsed or approved by us.

As a user of the Services, you agree not to:
  <p>-Systematically retrieve data or other content from the Services to create or compile, directly or indirectly, a
    collection, compilation, database, or directory without written permission from us.</p>
  <p>-Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account
    nformation such as user passwords.</p>
  <p>-Circumvent, disable, or otherwise interfere with security-related features of the Services, including features
    that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Services
    and/or the Content contained therein.</p>
  <p>-Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Services.</p>
  <p>-Use any information obtained from the Services in order to harass, abuse, or harm another person.</p>
  <p>-Make improper use of our support services or submit false reports of abuse or misconduct.</p>
  <p>-Use the Services in a manner inconsistent with any applicable laws or regulations.</p>
  <p>-Engage in unauthorized framing of or linking to the Services.</p>
  <p>-Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including
    excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any
    party’s uninterrupted use and enjoyment of the Services or modifies, impairs, disrupts, alters, or interferes
    with the use, features, functions, operation, or maintenance of the Services.</p>
  <p>-Engage in any automated use of the system, such as using scripts to send comments or messages, or using
    any data mining, robots, or similar data gathering and extraction tools.</p>
  <p>-Delete the copyright or other proprietary rights notice from any Content.</p>
  <p>-Attempt to impersonate another user or person or use the username of another user.</p>
  <p>-Upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active
    information collection or transmission mechanism, including without limitation, clear graphics interchange
    formats ("gifs"), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as "spyware"
    or "passive collection mechanisms" or "pcms").</p>
  <p>-Interfere with, disrupt, or create an undue burden on the Services or the networks or services connected to
    the Services.</p>
  <p>-Harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of
    the Services to you.</p>
  <p>-Attempt to bypass any measures of the Services designed to prevent or restrict access to the Services, or
    any portion of the Services.</p>
  <p>-Copy or adapt the Services' software, including but not limited to Flash, PHP, HTML, JavaScript, or other
    code.</p>
  <p>-Except as permitted by applicable law, decipher, decompile, disassemble, or reverse engineer any of the
    software comprising or in any way making up a part of the Services.</p>
  <p>-Except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or
    distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or
    offline reader that accesses the Services, or use or launch any unauthorized script or other software.</p>
  <p>-Use a buying agent or purchasing agent to make purchases on the Services.</p>
  <p>-Make any unauthorized use of the Services, including collecting usernames and/or email addresses of users
    by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by
    automated means or under false pretenses.</p>
  <p>-Use the Services as part of any effort to compete with us or otherwise use the Services and/or the Content
    for any revenue-generating endeavor or commercial enterprise.</p>


<h2 id="user_generated_contributions">5.USER GENERATED CONTRIBUTIONS</h2>


The Services does not offer users to submit or post content.

<h2 id="contribution_license">6.CONTRIBUTION LICENSE</h2>


You and Services agree that we may access, store, process, and use any information and personal data that you
provide following the terms of the Privacy Policy and your choices (including settings).

By submitting suggestions or other feedback regarding the Services, you agree that we can use and share such
feedback for any purpose without compensation to you.


<h2 id="services_management">7. SERVICES MANAGEMENT</h2>


<p>We reserve the right, but not the obligation, to: (1) monitor the Services for violations of these Legal Terms; (2) take
appropriate legal action against anyone who, in our sole discretion, violates the law or these Legal Terms, including
without limitation, reporting such user to law enforcement authorities; (3) in our sole discretion and without limitation,
refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of your
Contributions or any portion thereof; (4) in our sole discretion and without limitation, notice, or liability, to remove from
the Services or otherwise disable all files and content that are excessive in size or are in any way burdensome to our
systems; and (5) otherwise manage the Services in a manner designed to protect our rights and property and to
facilitate the proper functioning of the Services.
</p>

<h2 id="privacy_policy">8. Privacy Policy</h2>


<p>We care about data privacy and security. By using the Services, you agree to be bound by our Privacy Policy, which is incorporated into these Legal
Terms. Please be advised the Services are hosted in India, United Arab Emirates, United States and Saudi Arabia. If
you access the Services from any other region of the world with laws or other requirements governing personal data
collection, use, or disclosure that differ from applicable laws in India, United Arab Emirates, United States and Saudi
Arabia, then through your continued use of the Services, you are transferring your data to India, United Arab
Emirates, United States and Saudi Arabia, and you expressly consent to have your data transferred to and processed
in India, United Arab Emirates, United States and Saudi Arabia.
</p>

<h2 id="term-termination">9. TERM AND TERMINATION</h2>


<p>These Legal Terms shall remain in full force and effect while you use the Services. WITHOUT LIMITING ANY
OTHER PROVISION OF THESE LEGAL TERMS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION
AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SERVICES (INCLUDING
BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON,
INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT
CONTAINED IN THESE LEGAL TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE
YOUR USE OR PARTICIPATION IN THE SERVICES OR DELETE ANY CONTENT OR INFORMATION THAT YOU
POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.
</p>

<p>
If we terminate or suspend your account for any reason, you are prohibited from registering and creating a new
account under your name, a fake or borrowed name, or the name of any third party, even if you may be acting on
behalf of the third party. In addition to terminating or suspending your account, we reserve the right to take
appropriate legal action, including without limitation pursuing civil, criminal, and injunctive redress.
</p>

<h2 id="modifications">10. MODIFICATIONS AND INTERRUPTIONS</h2>
<p>We reserve the right to change, modify, or remove the contents of the Services at any time or for any reason at our
sole discretion without notice. However, we have no obligation to update any information on our Services. We will not
be liable to you or any third party for any modification, price change, suspension, or discontinuance of the Services..</p>

<p>
We cannot guarantee the Services will be available at all times. We may experience hardware, software, or other
problems or need to perform maintenance related to the Services, resulting in interruptions, delays, or errors. We
reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Services at any time or for
any reason without notice to you. You agree that we have no liability whatsoever for any loss, damage, or
inconvenience caused by your inability to access or use the Services during any downtime or discontinuance of the
Services. Nothing in these Legal Terms will be construed to obligate us to maintain and support the Services or to
supply any corrections, updates, or releases in connection therewith.
</p>


<h2 id="governing_law">11. GOVERNING LAW</h2>

<p>These Legal Terms shall be governed by and defined following the laws of UAE. JamNow ECOMMERCE
SOLUTIONS - FZCO and yourself irrevocably consent that the courts of India shall have exclusive jurisdiction to
resolve any dispute which may arise in connection with these Legal Terms.
</p>

<h2 id="dispute-resolution">12. DISPUTE RESOLUTION</h2>


<p>Informal Negotiations</p>

<p>To expedite resolution and control the cost of any dispute, controversy, or claim related to these Legal Terms (each a
"Dispute" and collectively, the "Disputes") brought by either you or us (individually, a "Party" and collectively, the
"Parties"), the Parties agree to first attempt to negotiate any Dispute (except those Disputes expressly provided
below) informally for at least thirty (30) days before initiating arbitration. Such informal negotiations commence upon
written notice from one Party to the other Party.
</p>
<p>Binding Arbitration</p>

<p>Any dispute arising out of or in connection with these Legal Terms, including any question regarding its existence,
validity, or termination, shall be referred to and finally resolved by the International Commercial Arbitration Court
under the European Arbitration Chamber (Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, UAE) according to the Rules of this
ICAC, which, as a result of referring to it, is considered as the part of this clause. The number of arbitrators shall be
__________. The seat, or legal place, or arbitration shall be India. The language of the proceedings shall be
__________. The governing law of these Legal Terms shall be substantive law of India.
</p>
<p>Restrictions</p>

<p>The Parties agree that any arbitration shall be limited to the Dispute between the Parties individually. To the full
extent permitted by law, (a) no arbitration shall be joined with any other proceeding; (b) there is no right or authority
for any Dispute to be arbitrated on a class-action basis or to utilize class action procedures; and (c) there is no right
or authority for any Dispute to be brought in a purported representative capacity on behalf of the general public or any
other persons.


<p>Exceptions to Informal Negotiations and Arbitration</p>


<p>The Parties agree that the following Disputes are not subject to the above provisions concerning informal negotiations
binding arbitration: (a) any Disputes seeking to enforce or protect, or concerning the validity of, any of the intellectual
property rights of a Party; (b) any Dispute related to, or arising from, allegations of theft, piracy, invasion of privacy, or
unauthorized use; and (c) any claim for injunctive relief. If this provision is found to be illegal or unenforceable, then
neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or
unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for
jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.</p> 


<h2 id="corrections">13. CORRECTIONS</h2>


<p>There may be information on the Services that contains typographical errors, inaccuracies, or omissions, including
descriptions, pricing, availability, and various other information. We reserve the right to correct any errors,
inaccuracies, or omissions and to change or update the information on the Services at any time, without prior notice.
</p>

<h2 id="disclaimer">14. DISCLAIMER</h2>


THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF
THE SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE
DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE
THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR
REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SERVICES' CONTENT OR THE
CONTENT OF ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO THE SERVICES AND WE WILL
ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF
CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE
WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICES, (3) ANY
UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL
INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR
CESSATION OF TRANSMISSION TO OR FROM THE SERVICES, (5) ANY BUGS, VIRUSES, TROJAN HORSES,
OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY THIRD PARTY,
AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR
DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED,
OR OTHERWISE MADE AVAILABLE VIA THE SERVICES. WE DO NOT WARRANT, ENDORSE, GUARANTEE,
OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD
PARTY THROUGH THE SERVICES, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE
APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO
OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRDPARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE
THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND
EXERCISE CAUTION WHERE APPROPRIATE.

<h2 id="limitations_of_liability">15. LIMITATIONS OF LIABILITY</h2>

IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD
PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING
FROM YOUR USE OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH
DAMAGES

<h2 id="indemnification">16. INDEMNIFICATION</h2>

You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective
officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including
reasonable attorneys’ fees and expenses, made by any third party due to or arising out of: (1) use of the Services; (2)
breach of these Legal Terms; (3) any breach of your representations and warranties set forth in these Legal Terms;
(4) your violation of the rights of a third party, including but not limited to intellectual property rights; or (5) any overt
harmful act toward any other user of the Services with whom you connected via the Services. Notwithstanding the
foregoing, we reserve the right, at your expense, to assume the exclusive defense and control of any matter for which
you are required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims. We
will use reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this
indemnification upon becoming aware of it.

<h2 id="user_data">17. USER DATA</h2>

We will maintain certain data that you transmit to the Services for the purpose of managing the performance of the
Services, as well as data relating to your use of the Services. Although we perform regular routine backups of data,
you are solely responsible for all data that you transmit or that relates to any activity you have undertaken using the
Services. You agree that we shall have no liability to you for any loss or corruption of any such data, and you hereby
waive any right of action against us arising from any such loss or corruption of such data.

<h2 id="electronic_communications_transactions">18. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</h2>

Visiting the Services, sending us emails, and completing online forms constitute electronic communications. You
consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other
communications we provide to you electronically, via email and on the Services, satisfy any legal requirement that
such communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES,
CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES,
AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SERVICES. You hereby
waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction
which require an original signature or delivery or retention of non-electronic records, or to payments or the granting of
credits by any means other than electronic means.

<h2 id="california_users_and_residents">19. CALIFORNIA USERS AND RESIDENTS</h2>

If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the Division of
Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N
112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254

<h2 id="miscellaneous">20. MISCELLANEOUS</h2>

These Legal Terms and any policies or operating rules posted by us on the Services or in respect to the Services
constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or
provision of these Legal Terms shall not operate as a waiver of such right or provision. These Legal Terms operate to
the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We
shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our
reasonable control. If any provision or part of a provision of these Legal Terms is determined to be unlawful, void, or
unenforceable, that provision or part of the provision is deemed severable from these Legal Terms and does not
affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership, employment
or agency relationship created between you and us as a result of these Legal Terms or use of the Services. You
agree that these Legal Terms will not be construed against us by virtue of having drafted them. You hereby waive any
and all defenses you may have based on the electronic form of these Legal Terms and the lack of signing by the
parties hereto to execute these Legal Terms


<h2 id="contact">21. CONTACT US</h2>
<p>If you have any questions, you can contact us at:</p>
<p>Email: <a href="mailto:online@xportbridge.com">online@xportbridge.com</a></p>
<p>Address: Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, United Arab Emirates</p>


<h2 id='privacy-policy-main'>Privacy Policy</h2>


Last updated 15 of June 2025


This Privacy Notice for JamNow - AL-MANAFEA ("we," "us," or "our"), describes how and why we might access,
collect, store, use, and/or share ("process") your personal information when you use our services ("Services"),
including when you:
 <p>-Visit our website at https://www.jamnow.store/, or any website of ours that links to this Privacy Notice</p>
 <p>-Engage with us in other related ways, including any sales, marketing, or events</p>

Questions or concerns? Reading this Privacy Notice will help you understand your privacy rights and choices. We
are responsible for making decisions about how your personal information is processed. If you do not agree with our
policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us
at online@xportbridge.com.

<h2>SUMMARY OF KEY POINTS</h2>

This summary provides key points from our Privacy Notice, but you can find out more details about any of
these topics by clicking the link following each key point or by using our table of contents below to find the
section you are looking for.


What personal information do we process? When you visit, use, or navigate our Services, we may process
personal information depending on how you interact with us and the Services, the choices you make, and the
products and features you use. Learn more about personal information you disclose to us.
Do we process any sensitive personal information? Some of the information may be considered "special" or
"sensitive" in certain jurisdictions, for example your racial or ethnic origins, sexual orientation, and religious beliefs.
We do not process sensitive personal information.


Do we collect any information from third parties? We do not collect any information from third parties.
How do we process your information? We process your information to provide, improve, and administer our
Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process
your information for other purposes with your consent. We process your information only when we have a valid legal
reason to do so. Learn more about how we process your information.


In what situations and with which parties do we share personal information? We may share information in
specific situations and with specific third parties. Learn more about when and with whom we share your personal
information.


How do we keep your information safe? We have adequate organizational and technical processes and
procedures in place to protect your personal information. However, no electronic transmission over the internet or
information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that
hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly
collect, access, steal, or modify your information. Learn more about how we keep your information safe.


What are your rights? Depending on where you are located geographically, the applicable privacy law may mean
you have certain rights regarding your personal information. Learn more about your privacy rights.
How do you exercise your rights? The easiest way to exercise your rights is by submitting a data subject access
request, or by contacting us. We will consider and act upon any request in accordance with applicable data protection
laws.


Want to learn more about what we do with any information we collect? Review the Privacy Notice in full


<h2>WHAT INFORMATION DO WE COLLECT?</h2>

Personal information you disclose to us
In Short: We collect personal information that you provide to us.
We collect personal information that you voluntarily provide to us when you express an interest in obtaining
information about us or our products and Services, when you participate in activities on the Services, or otherwise
when you contact us.

Personal Information Provided by You. The personal information that we collect depends on the context of your
interactions with us and the Services, the choices you make, and the products and features you use. The personal
information we collect may include the following:
 <p>-names</p>
 <p>-phone numbers</p>
 <p>-email addresses</p>
 <p>-mailing addresses</p>
 <p>-contact preferences</p>
 <p>-contact or authentication data</p>
 <p>-billing addresses</p>
 
Sensitive Information. We do not process sensitive information.
All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any
changes to such personal information.

Information automatically collected
In Short: Some information — such as your Internet Protocol (IP) address and/or browser and device characteristics
— is collected automatically when you visit our Services.

We automatically collect certain information when you visit, use, or navigate the Services. This information does not
reveal your specific identity (like your name or contact information) but may include device and usage information,
such as your IP address, browser and device characteristics, operating system, language preferences, referring
URLs, device name, country, location, information about how and when you use our Services, and other technical
information. This information is primarily needed to maintain the security and operation of our Services, and for our
internal analytics and reporting purposes.

Like many businesses, we also collect information through cookies and similar technologies.
The information we collect includes:

 <p>-Log and Usage Data. Log and usage data is service-related, diagnostic, usage, and performance
information our servers automatically collect when you access or use our Services and which we record in
log files. Depending on how you interact with us, this log data may include your IP address, device
information, browser type, and settings and information about your activity in the Services (such as the
date/time stamps associated with your usage, pages and files viewed, searches, and other actions you take
such as which features you use), device event information (such as system activity, error reports
(sometimes called "crash dumps"), and hardware settings).</p>

<p>-Device Data. We collect device data such as information about your computer, phone, tablet, or other device
you use to access the Services. Depending on the device used, this device data may include information
such as your IP address (or proxy server), device and application identification numbers, location, browser
type, hardware model, Internet service provider and/or mobile carrier, operating system, and system
configuration information.</p>

<p>-Location Data. We collect location data such as information about your device's location, which can be either
precise or imprecise. How much information we collect depends on the type and settings of the device you
use to access the Services. For example, we may use GPS and other technologies to collect geolocation
data that tells us your current location (based on your IP address). You can opt out of allowing us to collect
this information either by refusing access to the information or by disabling your Location setting on your
device. However, if you choose to opt out, you may not be able to use certain aspects of the Services.</p>

<p>This summary provides key points from our Privacy Notice:</p>
<ul>
    <li><strong>Personal Information:</strong> We may collect personal data such as name, email, phone number, and address.</li>
    <li><strong>Do we process sensitive information?</strong> No, we do not process sensitive personal information.</li>
    <li><strong>Third-party data collection:</strong> We do not collect information from third parties.</li>
    <li><strong>Data security:</strong> We take measures to protect your information but cannot guarantee complete security.</li>
</ul>

<h2 id="info-process">2. HOW DO WE PROCESS YOUR INFORMATION?</h2>
In Short: We process your information to provide, improve, and administer our Services, communicate with you, for
security and fraud prevention, and to comply with law. We may also process your information for other purposes with
your consent.

We process your personal information for a variety of reasons, depending on how you interact with our
Services, including:
<ul>
<li>To deliver and facilitate delivery of services to the user. We may process your information to provide
you with the requested service.</li>
<li>To respond to user inquiries/offer support to users. We may process your information to respond to your
inquiries and solve any potential issues you might have with the requested service.</li>
<li>To send administrative information to you. We may process your information to send you details about
our products and services, changes to our terms and policies, and other similar information.</li>
<li>To fulfill and manage your orders. We may process your information to fulfill and manage your orders,
payments, returns, and exchanges made through the Services.</li>
<li>To enable user-to-user communications. We may process your information if you choose to use any of
our offerings that allow for communication with another user.</li>
<li>To request feedback. We may process your information when necessary to request feedback and to
contact you about your use of our Services.</li>
<li>To send you marketing and promotional communications. We may process the personal information
you send to us for our marketing purposes, if this is in accordance with your marketing preferences. You can
opt out of our marketing emails at any time. For more information, see "WHAT ARE YOUR PRIVACY
RIGHTS?" below.</li>
<li>To deliver targeted advertising to you. We may process your information to develop and display
personalized content and advertising tailored to your interests, location, and more.</li>
<li>To evaluate and improve our Services, products, marketing, and your experience. We may process
your information when we believe it is necessary to identify usage trends, determine the effectiveness of our
promotional campaigns, and to evaluate and improve our Services, products, marketing, and your 
experience.</li>
<li>To identify usage trends. We may process information about how you use our Services to better
understand how they are being used so we can improve them.</li>
<li>To determine the effectiveness of our marketing and promotional campaigns. We may process your
information to better understand how to provide marketing and promotional campaigns that are most
relevant to you.</li>
<li>To comply with our legal obligations. We may process your information to comply with our legal
obligations, respond to legal requests, and exercise, establish, or defend our legal rights.</li>
</ul>

<h2 id="info-share">3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</h2>


In Short: We may share information in specific situations described in this section and/or with the following third
parties.
We may need to share your personal information in the following situations:
<ul>
<li>Business Transfers. We may share or transfer your information in connection with, or during negotiations
of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to
another company.
</li>
</ul>

<h2 id="cookies">4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</h2>


In Short: We may use cookies and other tracking technologies to collect and store your information.
We may use cookies and similar tracking technologies (like web beacons and pixels) to gather information when you
interact with our Services. Some online tracking technologies help us maintain the security of our Services, prevent
crashes, fix bugs, save your preferences, and assist with basic site functions.
We also permit third parties and service providers to use online tracking technologies on our Services for analytics
and advertising, including to help manage and display advertisements, to tailor advertisements to your interests, or to
send abandoned shopping cart reminders (depending on your communication preferences). The third parties and
service providers use their technology to provide advertising about products and services tailored to your interests
which may appear either on our Services or on other websites.

To the extent these online tracking technologies are deemed to be a "sale"/"sharing" (which includes targeted
advertising, as defined under the applicable laws) under applicable US state laws, you can opt out of these online
tracking technologies by submitting a request as described below under section "DO UNITED STATES RESIDENTS
HAVE SPECIFIC PRIVACY RIGHTS?"

Specific information about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Notice.

Google Analytics

We may share your information with Google Analytics to track and analyze the use of the Services. The Google
Analytics Advertising Features that we may use include: Remarketing with Google Analytics, Google Display Network
Impressions Reporting and Google Analytics Demographics and Interests Reporting. To opt out of being tracked by
Google Analytics across the Services, visit https://tools.google.com/dlpage/gaoptout. You can opt out of Google
Analytics Advertising Features through Ads Settings and Ad Settings for mobile apps. Other opt out means include
http://optout.networkadvertising.org/ and http://www.networkadvertising.org/mobile-choice. For more information on
the privacy practices of Google, please visit the Google Privacy & Terms page.

<h2 id="data-retention">5. HOW LONG DO WE KEEP YOUR INFORMATION?</h2>

<p>In Short: We keep your information for as long as necessary to fulfill the purposes outlined in this Privacy Notice
unless otherwise required by law.</p>

<p>We will only keep your personal information for as long as it is necessary for the purposes set out in this Privacy
Notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal
requirements).</p>

<p>When we have no ongoing legitimate business need to process your personal information, we will either delete or
anonymize such information, or, if this is not possible (for example, because your personal information has been
stored in backup archives), then we will store your personal information in a secure backup archive.</p> 

<h2 id="data-security">6. HOW DO WE KEEP YOUR INFORMATION SAFE?</h2>

<p>In Short: We aim to protect your personal information through a system of organizational and technical security
measures.</p>

<p>We have implemented appropriate and reasonable technical and organizational security measures designed to
protect the security of any personal information we process. However, despite our safeguards and efforts to secure
your information, no electronic transmission over the Internet or information storage technology can be guaranteed to
be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties
will not be able to defeat our security and improperly collect, access, steal, or modify your information. Although we
will do our best to protect your personal information, transmission of personal information to and from our Services is
at your own risk. You should only access the Services within a secure environment.</p>

<h2 id="minors">7. DO WE COLLECT INFORMATION FROM MINORS?</h2>

<p>In Short: We do not knowingly collect data from or market to children under 18 years of age.</p>
<p>We do not knowingly collect, solicit data from, or market to children under 18 years of age, nor do we knowingly sell
such personal information. By using the Services, you represent that you are at least 18 or that you are the parent or
guardian of such a minor and consent to such minor dependent’s use of the Services. If we learn that personal
information from users less than 18 years of age has been collected, we will deactivate the account and take
reasonable measures to promptly delete such data from our records. If you become aware of any data we may have
collected from children under age 18, please contact us at online@xportbridge.com.</p>

<h2 id="privacy-rights">8. WHAT ARE YOUR PRIVACY RIGHTS?</h2>

<p>In Short: You may review, change, or terminate your account at any time, depending on your country, province, or
state of residence.</p>

<p>Withdrawing your consent: If we are relying on your consent to process your personal information, which may be
express and/or implied consent depending on the applicable law, you have the right to withdraw your consent at any
time. You can withdraw your consent at any time by contacting us by using the contact details provided in the section
"HOW CAN YOU CONTACT US ABOUT THIS NOTICE?" below.</p>

<p>However, please note that this will not affect the lawfulness of the processing before its withdrawal nor, when
applicable law allows, will it affect the processing of your personal information conducted in reliance on lawful
processing grounds other than consent.</p>

<p>Cookies and similar technologies: Most Web browsers are set to accept cookies by default. If you prefer, you can
usually choose to set your browser to remove cookies and to reject cookies. If you choose to remove cookies or
reject cookies, this could affect certain features or services of our Services.</p>
<p>If you have questions or comments about your privacy rights, you may email us at online@xportbridge.com</p>

<h2 id="updates">9. CONTROLS FOR DO-NOT-TRACK FEATURES</h2>


Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ("DNT")
feature or setting you can activate to signal your privacy preference not to have data about your online browsing
activities monitored and collected. At this stage, no uniform technology standard for recognizing and implementing
DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other
mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is
adopted that we must follow in the future, we will inform you about that practice in a revised version of this Privacy
Notice.

California law requires us to let you know how we respond to web browser DNT signals. Because there currently is
not an industry or legal standard for recognizing or honoring DNT signals, we do not respond to them at this time.


<h2 id="updates">10. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h2>


In Short: If you are a resident of California, Colorado, Connecticut, Delaware, Florida, Indiana, Iowa, Kentucky,
Minnesota, Montana, Nebraska, New Hampshire, New Jersey, Oregon, Tennessee, Texas, Utah, or Virginia, you
may have the right to request access to and receive details about the personal information we maintain about you
and how we have processed it, correct inaccuracies, get a copy of, or delete your personal information. You may also
have the right to withdraw your consent to our processing of your personal information. These rights may be limited in
some circumstances by applicable law. More information is provided below.

Categories of Personal Information We Collect
We have collected the following categories of personal information in the past twelve (12) months:
Category
Examples
Collected
A. Identifiers
Contact details, such as real name, alias, postal address, telephone or mobile contact number, unique personal
identifier, online identifier, Internet Protocol address, email address, and account name
YES

B. Personal information as defined in the California Customer Records statute
Name, contact information, education, employment, employment history, and financial information
YES

C. Protected classification characteristics under state or federal lawC. Protected classification characteristics under
state or federal law
Gender, age, date of birth, race and ethnicity, national origin, marital status, and other demographic data
YES

D. Commercial information
Transaction information, purchase history, financial details, and payment information
NO

E. Biometric information
Fingerprints and voiceprints
NO

F. Internet or other similar network activity
Browsing history, search history, online behavior, interest data, and interactions with our and other websites,
applications, systems, and advertisements
YES

G. Geolocation data
Device location
YES

H. Audio, electronic, sensory, or similar information
Images and audio, video or call recordings created in connection with our business activities
NO

I. Professional or employment-related information
Business contact details in order to provide you our Services at a business level or job title, work history, and
professional qualifications if you apply for a job with us
NO

J. Education Information
Student records and directory information
NO

K. Inferences drawn from collected personal information
Inferences drawn from any of the collected personal information listed above to create a profile or summary about, for
example, an individual’s preferences and characteristics
YES

L. Sensitive personal Information
NO

We may also collect other personal information outside of these categories through instances where you interact with
us in person, online, or by phone or mail in the context of:
Receiving help through our customer support channels;
Participation in customer surveys or contests; and
Facilitation in the delivery of our Services and to respond to your inquiries.

We will use and retain the collected personal information as needed to provide the Services or for:

Category A - 6 months

Category B - 6 months

Category C - 6 months

Category F - 6 months

Category G - 6 months

Category K - 6 months

Sources of Personal Information
Learn more about the sources of personal information we collect in "WHAT INFORMATION DO WE COLLECT?"
How We Use and Share Personal Information

Learn more about how we use your personal information in the section, "HOW DO WE PROCESS YOUR
INFORMATION?"

Will your information be shared with anyone else?
We may disclose your personal information with our service providers pursuant to a written contract between us and
each service provider. Learn more about how we disclose personal information to in the section, "WHEN AND WITH
WHOM DO WE SHARE YOUR PERSONAL INFORMATION?"

We may use your personal information for our own business purposes, such as for undertaking internal research for
technological development and demonstration. This is not considered to be "selling" of your personal information.
We have not disclosed, sold, or shared any personal information to third parties for a business or commercial
purpose in the preceding twelve (12) months. We will not sell or share personal information in the future belonging to
website visitors, users, and other consumers.

Your Rights
You have rights under certain US state data protection laws. However, these rights are not absolute, and in certain
cases, we may decline your request as permitted by law. These rights include:

Right to know whether or not we are processing your personal data

Right to access your personal data

Right to correct inaccuracies in your personal data

Right to request the deletion of your personal data

Right to obtain a copy of the personal data you previously shared with us

Right to non-discrimination for exercising your rights

Right to opt out of the processing of your personal data if it is used for targeted advertising (or sharing as defined
under California’s privacy law), the sale of personal data, or profiling in furtherance of decisions that produce legal or
similarly significant effects ("profiling")

Depending upon the state where you live, you may also have the following rights:

Right to access the categories of personal data being processed (as permitted by applicable law, including
Minnesota’s privacy law)

Right to obtain a list of the categories of third parties to which we have disclosed personal data (as permitted by
applicable law, including California's and Delaware's privacy law)

Right to obtain a list of specific third parties to which we have disclosed personal data (as permitted by applicable
law, including Minnesota's and Oregon's privacy law)

Right to review, understand, question, and correct how personal data has been profiled (as permitted by applicable
law, including Minnesota’s privacy law)

Right to limit use and disclosure of sensitive personal data (as permitted by applicable law, including California’s
privacy law)

Right to opt out of the collection of sensitive data and personal data collected through the operation of a voice or
facial recognition feature (as permitted by applicable law, including Florida’s privacy law)

How to Exercise Your Rights
To exercise these rights, you can contact us by submitting a data subject access request, by emailing us at
online@xportbridge.com.com, or by referring to the contact details at the bottom of this document.
Under certain US state data protection laws, you can designate an authorized agent to make a request on your
behalf. We may deny a request from an authorized agent that does not submit proof that they have been validly
authorized to act on your behalf in accordance with applicable laws.

Request Verification
Upon receiving your request, we will need to verify your identity to determine you are the same person about whom
we have the information in our system. We will only use personal information provided in your request to verify your
identity or authority to make the request. However, if we cannot verify your identity from the information already
maintained by us, we may request that you provide additional information for the purposes of verifying your identity
and for security or fraud-prevention purposes.

If you submit the request through an authorized agent, we may need to collect additional information to verify your
identity before processing your request and the agent will need to provide a written and signed permission from you
to submit such request on your behalf.

Appeals

Under certain US state data protection laws, if we decline to take action regarding your request, you may appeal our
decision by emailing us at online@xportbridge.com. We will inform you in writing of any action taken or not taken in
response to the appeal, including a written explanation of the reasons for the decisions. If your appeal is denied, you
may submit a complaint to your state attorney general.

California "Shine The Light" Law

California Civil Code Section 1798.83, also known as the "Shine The Light" law, permits our users who are California
residents to request and obtain from us, once a year and free of charge, information about categories of personal
information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all
third parties with which we shared personal information in the immediately preceding calendar year. If you are a
California resident and would like to make such a request, please submit your request in writing to u


<h2>11.DO WE MAKE UPDATES TO THIS NOTICE?</h2>
In Short: Yes, we will update this notice as necessary to stay compliant with relevant laws.

We may update this Privacy Notice from time to time. The updated version will be indicated by an updated "Revised"
date at the top of this Privacy Notice. If we make material changes to this Privacy Notice, we may notify you either by
prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review
this Privacy Notice frequently to be informed of how we are protecting your information.

<h2>12.HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h2>

If you have questions or comments about this notice, you may email us at online@xportbridge.com or contact us by
post at:
AL-MANAFEA Commercial
7244 King Saud Bin Abdulaziz Rd,
Al Dawhah Al Janubiyah,
Dhahran 34455, Saudi Arabia

<h2 id="contact">13.HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT
FROM YOU?</h2>


Based on the applicable laws of your country or state of residence in the US, you may have the right to request
access to the personal information we collect from you, details about how we have processed it, correct inaccuracies,
or delete your personal information. You may also have the right to withdraw your consent to our processing of your
personal information. These rights may be limited in some circumstances by applicable law. To request to review,
update, or delete your personal information, please contact us.
`;

const LegalsOkie = ({ handleLink }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { isTablet } = useGlobal();

  useEffect(() => {
    setTimeout(() => {
      const anchor = window.location.hash.slice(1);
      handleLink(anchor);
    }, 0);
  }, []);

  return (
    <>
      <Helmet>
        <meta data-react-helmet="true" name="robots" content="index, follow" />
      </Helmet>
      <MobileHeaderLayout content={<MobileHeaderTitle text={t('legals')} />} />
      <div className="content-layout legals">
        <div className={styles.root}>
          {!isTablet && (
            <>
              <Breadcrumbs
                items={
                  [
                    {
                      text: t('home'),
                      link: '/',
                    },
                    {
                      text: t('legals'),
                      link: '/legals',
                    },
                  ].filter(Boolean) as BreadcrumbsItem[]
                }
              />

              <h2 className={styles.title}>{t('legals')}</h2>
            </>
          )}

          <div className={styles.page}>
            <div className={styles.page__links_container}>
              <ul className={styles.page__links}>
                {LEGALS_NAV.map((i) => (
                  <li className={styles.page__links_item} key={i.link}>
                    <a
                      href={`#${i.link}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLink(i.link);
                      }}
                    >
                      {i.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.page__content}>
              <ReactMarkdown
                className={mdStyles.mdStyles}
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
              >
                {text}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LegalsOkie;
